import { useLocalStore } from '@kts-front/hooks';
import { Center, Loader } from '@mantine/core';
import * as React from 'react';
import { Helmet } from 'react-helmet';
import { Outlet } from 'react-router-dom';

import CreateMeetingDrawer from 'components/shared/CreateMeetingDrawer';
import LeadDrawer from 'components/shared/LeadDrawer';
import MeetingDrawer from 'components/shared/MeetingDrawer';
import MeetingUpdateDrawer from 'components/shared/MeetingUpdateDrawer';
import PushSubscribeModal from 'components/shared/PushSubscribeModal';
import TeamResponsibleDrawer from 'components/shared/TeamResponsibleDrawer';
import { CreateMeetingDrawerModal, CreateMeetingDrawerModalProvider } from 'stores/global/CreateMeetingDrawerModal';
import { notificationsStore } from 'stores/global/RootStore';
import { defaultAppConfig } from 'stores/global/RootStore/AppConfigStore';
import {
  MeetingUpdateDrawerModal,
  MeetingUpdateDrawerModalProvider,
} from 'stores/global/RootStore/MeetingUpdateDrawerModal';
import QueryParamsStoreInitializer from 'stores/global/RootStore/QueryParamsStore/QueryParamsStoreConnector';
import { useAppConfig } from 'stores/global/RootStore/context';

import '@mantine/core/styles.css';

const RootLayout: React.FC = () => {
  const { images, logic } = useAppConfig();
  const { store: createMeetingStore } = useLocalStore(
    () =>
      new CreateMeetingDrawerModal({
        notificationStore: notificationsStore,
        optionalFields: logic.meeting.optionalFields,
        shownFields: logic.meeting.shownFields,
        checkUniqueClientMethod: logic.meeting.checkUniqueClient,
        filterByUniqueClientsAndLeads: logic.meeting.filterByUniqueClientsAndLeads,
      }),
  );
  const { store: updateMeetingStore } = useLocalStore(
    () =>
      new MeetingUpdateDrawerModal({
        notificationStore: notificationsStore,
        optionalFields: logic.meeting.updateOptionalFields,
        shownFields: logic.meeting.updateShownFields,
      }),
  );

  return (
    <>
      <Helmet>
        {defaultAppConfig.images.startImageUrlWebp && (
          <link
            rel="preload"
            href={images.startImageUrlWebp ?? defaultAppConfig.images.startImageUrlWebp}
            as="image"
            type="image/webp"
          />
        )}
      </Helmet>
      <QueryParamsStoreInitializer>
        <CreateMeetingDrawerModalProvider store={createMeetingStore}>
          <MeetingUpdateDrawerModalProvider store={updateMeetingStore}>
            <React.Suspense
              fallback={
                <Center>
                  <Loader />
                </Center>
              }
            >
              <Outlet />
              <LeadDrawer />
              <MeetingDrawer />
              <CreateMeetingDrawer />
              <TeamResponsibleDrawer />
              <MeetingUpdateDrawer />
            </React.Suspense>
          </MeetingUpdateDrawerModalProvider>
        </CreateMeetingDrawerModalProvider>
        <PushSubscribeModal />
      </QueryParamsStoreInitializer>
    </>
  );
};

export default RootLayout;
